<template>
  <div class="show-route-block">
    <div id="show-route"></div>
    <div class="show-route-white">

    </div>
  </div>
</template>

<script>
export default {
  name: 'show-route',
  data() {
    return {
      route_id: 1,
      route_mode: this.routeMode, // 路线 类型：公交、驾车、徒步、骑行
      // 起点：
      from_lat: this.fromLat,
      from_lng: this.fromLng,
      // 终点：
      to_lat: this.toLat,
      to_lng: this.toLng,
      // 定位点-辅助
      lat: 39.984039,
      lng: 116.307630307503,
      // 地图
      map: {},
      marker: {}, // 点标记的对象，用于增加和删除
      polylineLayer: null, // 折线的对象，用于增加和删除
      pointerListOnMap: [],
    }
  },
  props: {
    routeMode: {
      type: String,
      default: 'walking',
    },
    fromLat: {
      type: Number,
      default: 39.984039,
    },
    fromLng: {
      type: Number,
      default: 116.30763,
    },
    toLat: {
      type: Number,
      default: 39.977263,
    },
    toLng: {
      type: Number,
      default: 116.337063,
    },
  },
  watch: {
    routeMode(newVal) {
      this.route_mode = newVal
    },
    fromLat(newVal) {
      this.from_lat = newVal
    },
    fromLng(newVal) {
      this.from_lng = newVal
    },
    toLat(newVal) {
      this.to_lat = newVal
    },
    toLng(newVal) {
      this.to_lng = newVal
    },
  },
  mounted() {
    this.init()
  },

  methods: {
    // 初始化地图
    init() {
      // let center = new TMap.LatLng(this.lat, this.lng)
      // ------------------初始化地图------------------
      this.map = new TMap.Map('show-route', {
        zoom: 12, //设置地图缩放级别
        mapStyleId: 'style1',
        // center: center, //设置地图中心点坐标
      })
      // 去掉比例尺\
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE)
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION)
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM)
      // ------------------创建 点标记实例------------------
      this.marker = new TMap.MultiMarker({
        map: this.map,
        // 标记点的样式，其中myStyle 为定义的标记点的名称，在geometries的属性是使用
        styles: {
          markerStyle: new TMap.MarkerStyle({
            width: 17,
            height: 17,
            anchor: { x: 8, y: 16 },
            src: 'http://szsxtravel.top/%E5%9D%90%E6%A0%87.png',
          }),
          selectTraver: new TMap.MarkerStyle({
            width: 35,
            height: 35,
            anchor: { x: 16, y: 32 },
            src: 'http://szsxtravel.top/%E5%9D%90%E6%A0%87.png',
          }),
        },
        geometries: [], //点标记数据数组
      })

      // ------------------创建 MultiPolyline显示折线------------------
      this.polylineLayer = new TMap.MultiPolyline({
        id: 'polyline-layer', //图层唯一标识
        map: this.map, //绘制到目标地图
        //折线样式定义
        styles: {
          // 【蓝色】为折线的样式名称
          style_driving: new TMap.PolylineStyle({
            color: '#3777FF', //线填充色
            width: 4, //折线宽度
            borderWidth: 5, //边线宽度
            borderColor: '#FFF', //边线颜色
            lineCap: 'round', //线端头方式
          }),
          // 【绿色】为折线的样式名称 - 步行
          style_walking: new TMap.PolylineStyle({
            color: '#2ECC71', //线填充色
            width: 4, //折线宽度
            // borderWidth: 5, //边线宽度
            // borderColor: '#FFF', //边线颜色
            // lineCap: 'round', //线端头方式
            dashArray: [10, 10], //虚线展示方式
          }),
          // 【绿色】为折线的样式名称 - 地铁
          style_subway: new TMap.PolylineStyle({
            color: '#FF5421', //线填充色
            width: 4, //折线宽度
            // borderWidth: 5, //边线宽度
            borderColor: '#FFF', //边线颜色
            lineCap: 'round', //线端头方式
            // dashArray: [10, 10], //虚线展示方式
          }),
          // 【绿色】为折线的样式名称 - 骑行
          style_bicycling: new TMap.PolylineStyle({
            color: '#ABEBC6', //线填充色
            width: 4, //折线宽度
            // borderWidth: 5, //边线宽度
            borderColor: '#FFF', //边线颜色
            lineCap: 'round', //线端头方式
            // dashArray: [10, 10], //虚线展示方式
          }),
        },
        //折线数据定义
        geometries: [],
      })
      // ------------------【结束】创建 路线桂湖/点标记实例------------------
    },
    // ----------------更新ployling对象 和 Marker 对象----------------
    // 解压，参数：  折线数据/交通id/路线模式
    updateBack(res, TrafficId, routeMode) {
      // console.log('路线信息,traffic_id:', TrafficId)
      // console.log('解压路线信息,polyline:', res)
      let coors = res.polyline
      let pl = []
      //坐标解压（返回的点串坐标，通过前向差分进行压缩）
      let kr = 1000000
      for (let i = 2; i < coors.length; i++) {
        coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
      }
      //将解压后的坐标生成LatLng数组
      for (var i = 0; i < coors.length; i += 2) {
        pl.push(new TMap.LatLng(coors[i], coors[i + 1]))
      }
      // 添加折线
      this.addRoutesAndPoint(pl, TrafficId, routeMode)
    },
    // 增加 折线【废弃】
    addRoutesAndPoint(pl, TrafficId, routeMode) {
      if (routeMode == 'walking') {
        this.polylineLayer.add({
          //新的折线添加到图层中
          id: TrafficId,
          styleId: 'style_walking',
          paths: pl,
        })
      } else if (routeMode == 'driving') {
        this.polylineLayer.add({
          //新的折线添加到图层中
          id: TrafficId,
          styleId: 'style_blue',
          paths: pl,
        })
      } else if (routeMode == 'bicycling') {
        this.polylineLayer.add({
          //新的折线添加到图层中
          id: TrafficId,
          styleId: 'style_green',
          paths: pl,
        })
      } else if (routeMode == 'transit') {
        // 批量添加折线
        this.polylineLayer.add({
          //新的折线添加到图层中
          id: TrafficId,
          styleId: 'style_blue',
          paths: pl,
        })
      }
    },
    // 批量 增加 折线 【废弃】
    addRoutesAll(pl_list) {
      // 批量添加折线
      this.polylineLayer.add(pl_list)
    },
    // 添加 标记点
    addMarkerPointer(LatLng_list) {
      let fromToPoiOnMap = []
      LatLng_list.forEach((i) => {
        let item = {
          // 列表选项参考文档：https://lbs.qq.com/webApi/javascriptGL/glGuide/glMarker
          id: i.id,
          styleId: 'markerStyle', // 标记点的样式
          position: new TMap.LatLng(i.lat, i.lng),
          properties: {
            //自定义属性
            title: 'marker1',
          },
        }
        fromToPoiOnMap.push(item)
      })
      console.log(fromToPoiOnMap)
      // 添加坐标
      // this.marker.add(fromToPoiOnMap)
      // 更新坐标
      this.marker.updateGeometries(fromToPoiOnMap)
      // 设置中心
      this.showMarkerBounds(fromToPoiOnMap)
      // this.map.setCenter(center)
    },
    // 移除点坐标
    removeMarkerPointer(marker_id) {
      // console.log(this.marker.remove(marker_id))
      this.marker.remove(marker_id)
    },
    // 更新点标记
    updateMarker(marker_list) {
      this.marker.updateGeometries(marker_list)
      this.showMarkerBounds(marker_list)
    },
    // 更新折线数据 setGeometries
    updateRoutes(polyline_item_list) {
      this.polylineLayer.setGeometries(polyline_item_list)
    },
    // 删除已有折线
    removeRoutes(traffic_id) {
      // console.log('移除路线')
      // 通过 图层ID，移除polyline-layer图层
      this.polylineLayer.remove(traffic_id)
    },
    // -----------------------------显示地图边界-----------------------------
    showMarkerBounds(markerArr) {
      // 创建对象：描述一个矩形的地理坐标范围。https://lbs.qq.com/javascript_gl/doc/latlngbounds.html
      var bounds = new TMap.LatLngBounds()
      //判断标注点是否在范围内
      markerArr.forEach(function (item) {
        //若坐标点不在范围内，扩大bounds范围
        if (bounds.isEmpty() || !bounds.contains(item.position)) {
          bounds.extend(item.position)
        }
      })
      //设置地图可视范围
      this.map.fitBounds(bounds, {
        padding: 50, // 自适应边距
      })
    },
  },
}
</script>

<style>
#show-route {
  width: auto;
  height: 300px;
}
.show-route-block {
  position: relative;
}
.show-route-white {
  text-align: center;
  font-size: 15px;
  position: absolute;
  bottom: 0px;
  z-index: 1001;
  height: 30px;
  width: 100%;
  background-color: #fff;
}
</style>